import {ElementModel} from "./ElementModel";

export class LineModel extends ElementModel{
  constructor(position: number) {
    super(position);
  }
}
